import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function TravelPage() {
  return <IndustryDetailPage slug="travel" />;
}